import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useGetConnectionsQuery } from "@/services/it/updates/query-connections";

interface Connection {
  id: number;
  connection_nickname?: string;
}

interface SelectConnectionsProps {
  onValueChange?: (value: string) => void;
}

export default function SelectConnections({
  onValueChange,
}: SelectConnectionsProps) {
  const { data: connections, isLoading: loadingConnections } =
    useGetConnectionsQuery({
      search: "",
      orderBy: JSON.stringify("asc"),
      perPage: 10,
      meta: {
        page: 1,
      },
    });

  if (loadingConnections) {
    return <div></div>;
  }

  const defaultValue =
    connections?.data && connections.data.length > 0
      ? connections.data[connections.data.length - 1].id.toString()
      : undefined;
      
  return (
    <Select onValueChange={onValueChange} defaultValue={defaultValue}>
      <SelectTrigger className="w-full px-5">
        <SelectValue placeholder="Escolha um banco" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Conexões</SelectLabel>
          {connections?.data.map((connection: Connection) => (
            <SelectItem key={connection.id} value={connection.id.toString()}>
              {connection.connection_nickname}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
